import type { ChildEntity } from './entity/childEntity';
import type { ChildIRepository } from './entity/childIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';
import { DeleteType } from '@/domain/entityRepositoryBase';
import { api } from '@/share';

export class ChildDomainService extends DomainServiceBase {
  private childRepository!: ChildIRepository;

  /**
   * Injection
   * @param childRepository childRepository
   */
  public inject(
    childRepository: ChildIRepository,
  ) {
    this.childRepository = childRepository;
  }

  /**
   * 子どもリスト取得
   * @returns リスト
   */
  async getChildList() {
    const items = await this.childRepository.getAllList();
    return items;
  }

  /**
   * createChild
   * @param entity 入力
   * @returns 結果
   */
  async createChild(entity: ChildEntity) {
    const result = await this.childRepository.create(entity);
    return result;
  }

  /**
   * updateChild
   * @param entity 入力
   * @returns 結果
   */
  async updateChild(entity: ChildEntity) {
    const result = await this.childRepository.update(entity);
    return result;
  }

  /**
   * deleteChild
   * @param entity 入力
   * @returns 結果
   */
  async deleteChild(entity: ChildEntity) {
    const result = await this.childRepository.delete(entity);
    await api.wagakoAppApi.deleteData({
      deleteType: DeleteType.ParentChildId,
      deleteKey: entity.parentChildId,
    });
    return result;
  }
}
